import { NavLink } from 'react-router-dom';

import { Icon } from '@/components/ui';
import { cn } from '@/utils/cn';

/**
 * A row of tabs where each tab is its own page (and its own URL), for a
 * sidebar entry that stands for several related pages.
 *
 * `tabs` is `[{ to, label, icon }]`.
 */
export function RouteTabs({ label, tabs }) {
  return (
    <nav
      aria-label={label}
      // The base line is an inset shadow, not a border the tabs overlap with
      // a negative margin: that 1px overhang made this row scroll vertically
      // and showed a scrollbar. It still scrolls sideways on a narrow phone.
      className="shadow-line mb-6 flex max-w-full items-end gap-1 overflow-x-auto overflow-y-hidden shadow-[inset_0_-1px_0] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
    >
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end
          className={({ isActive }) =>
            cn(
              'flex items-center gap-1.5 border-b-2 px-3 py-2 text-[13px] font-medium whitespace-nowrap transition',
              isActive
                ? 'border-brand-600 text-brand-700'
                : 'text-ink-muted hover:text-ink border-transparent',
            )
          }
        >
          <Icon name={tab.icon} size={14} />
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
